(ns fablo-offers.common.lib.i18n
  (:require ["./translations" :refer [resources]]
            ["i18next" :as i18n]
            ["i18next-browser-languagedetector" :as LanguageDetector]
            ["react-i18next" :as i18n-react :refer [initReactI18next]]
            [cljs-bean.core :refer [->js]]
            [fablo-offers.common.tracking :as tracking]
            [lambdaisland.glogi :as log]
            [clojure.string :as string]))

(defn on-missing-key [lang namespace key]
  (log/error :i18n-missing-key
             {:lang lang
              :namespace namespace
              :key key}))

(defn init!
  []
  (-> i18n
      (.use LanguageDetector)
      (.use initReactI18next)
      ;(.on "missingKey" on-missing-key)
      (.init (->js
              {:detection
               {:order ["querystring" "localStorage" "navigator"]
                :lookupQuerystring "lang"
                :lookupLocalStorage "lang"
                :caches ["localStorage"]
                :excludeCacheFor ["cimode"]
                :convertDetectedLanguage (fn [lng] (string/replace lng #"-.*" ""))}
               :defaultNS [""]
               :supportedLngs ["pl" "en"]
               :nonExplicitSupportedLngs true
               :load "languageOnly"
               :saveMissing true
               :resources resources
               :fallbackLng "en"
               ; react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
               :interpolation {:escapeValue false}
               :debug false}))))

(init!)

(defn refresh!
  [{:keys [on-success on-failure]
    :or {on-success identity
         on-failure identity}}]
  (-> (i18n/reloadResources)
      (.then on-success)
      (.catch on-failure)))

(defn t
  ([k]
   (t k {}))
  ([k opts]
   (if (map? k)
     (get k (keyword i18n/language) (first (vals k)))
     (i18n/t (str (namespace k) ":" (name k)) (->js opts)))))

(defn language []
  i18n/language)

(defn locale []
  (case (language)
    "en" "en-US"
    "pl-PL"))

(defn change-language!
  ([lang]
   (change-language! lang {}))
  ([lang {:keys [silent?]}]
   (let [before-change (language)
         ident :language-change-success]
     (tracking/track "Language changed" {:language lang})
     (->
      (i18n/changeLanguage lang)
      (.then (fn []
               (.reload js/location)))
      (.catch (fn [err]
                (log/error :i18n-lang-change-error err)))))))

(def trans i18n-react/Trans)

(defn add-translations [lang ns m]
  (.addResourceBundle
   i18n
   (name lang)
   (name ns)
   (clj->js m)))

(defn strans [x]
  (cond
    (= (language) "en") (:en x)
    (= (language) "pl") (:pl x)
    :else (:en x)))
